import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const OpenInternalIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 25),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "2",
    children: [/*#__PURE__*/jsx("path", {
      d: "m10.29 15 7.55-7.52",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsxs("g", {
      transform: "translate(-684 -371)",
      children: [/*#__PURE__*/jsx("path", {
        d: "m697.05 377.32h6v6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("rect", {
        height: "23",
        rx: "2",
        width: "23",
        x: "685",
        y: "372"
      })]
    })]
  });
};

export { OpenInternalIcon };
//# sourceMappingURL=open.internal.js.map
